<section *ngIf="marcas.length>0" class="container-fluid pt-0 pb-0 bg-white">
  <div class="js-slider">
    <div *ngFor="let marca of marcas" class="slider__item">
      <a [href]="marca.url" target="_self" [title]="'Ver productos de ' + marca.name">
        <img [src]="marca.image" [alt]="marca.name" class="img-fluid mh-130" />
      </a>
    </div>
  </div>
</section>